import BaseEntityModel from "./../general/BaseEntityModel";
import defaultImg from "@/assets/images/users.svg";
import UserWalletData from "./UserWalletData";
import UserProfile from "./UserProfile";
import EstablishmentRole from "./../settings/establishmentRoles/EstablishmentRole";

export default class User extends BaseEntityModel {
  icon = defaultImg;
  defaultImg = defaultImg;
  constructor() {
    super();
    this.setInitialValue();
  }

  setInitialValue() {
    this.setInitialValueBaseEntityModel();
    this.mediaFile = "";
    this.userToken = "";
    this.userNameCurrent = "";
    this.userNameAr = "";
    this.userNameEn = "";
    this.userNameUnd = "";
    this.userPassword = "";
    this.userPhoneCountryCode = "";
    this.userPhoneCountryCodeName = "";
    this.userPhone = "";
    this.userPhoneWithCC = "";
    this.userEmail = "";
    this.userName = "";
    this.userTypeToken = "";
    this.userTypeNameCurrent = "";
    this.userImagePath = "";
    this.userImageIsDefault = false;
    this.userImageSizeBytes = 0;
    this.userImageSizeTextCurrent = "";
    this.userChildren = [];
    this.userParentsData = [];
    this.establishmentRoleToken = "";
    this.userWalletData = new UserWalletData();
    this.userProfileData = new UserProfile();
    this.establishmentRoleData = new EstablishmentRole();
  }
  fillData(data) {
    if (data) {
      this.fillDataBaseEntityModel(data);
      this.mediaFile = "";
      this.userToken = data.userToken ?? "";
      this.userNameCurrent = data.userNameCurrent ?? "";
      this.userNameAr = data.userNameAr ?? "";
      this.userNameEn = data.userNameEn ?? "";
      this.userNameUnd = data.userNameUnd ?? "";
      this.userPassword = data.userPassword ?? "";
      this.userPhoneCountryCode = data.userPhoneCountryCode ?? "";
      this.userPhoneCountryCodeName = data.userPhoneCountryCodeName ?? "";
      this.userPhone = data.userPhone ?? "";
      this.userPhoneWithCC = data.userPhoneWithCC ?? "";
      this.userEmail = data.userEmail ?? "";
      this.userName = data.userName ?? "";
      this.userTypeToken = data.userTypeToken ?? "";
      this.userTypeNameCurrent = data.userTypeNameCurrent ?? "";
      this.userImagePath = data.userImagePath ?? "";
      this.userImageIsDefault = data.userImageIsDefault ?? false;
      this.userImageSizeBytes = data.userImageSizeBytes ?? 0;
      this.userImageSizeTextCurrent = data.userImageSizeTextCurrent ?? "";
      this.userChildren = data.userChildren ?? [];
      this.userParentsData = data.userParentsData ?? [];
      this.establishmentRoleToken = data.establishmentRoleToken ?? "";
      this.userWalletData.fillData(data.userWalletData);
      this.userProfileData.fillData(data.userProfileData);
      this.establishmentRoleData.fillData(data.establishmentRoleData);
    } else {
      // comment
      this.setInitialValue();
    }
  }
}
//#endregion model
